export default __webpack_public_path__ + "static/media/noa-14.e2081e0a.jpg";